const skillsDetails = [
  {
    title: "",
    details: "Goal achiever",
    url: "https://cdn-icons-png.flaticon.com/512/4727/4727555.png",
  },
  {
    title: "",
    details: "Team player",
    url: "https://cdn-icons-png.flaticon.com/512/4727/4727533.png",
  },
  {
    title: "",
    details: "Extraordenary problem solving skills",
    url: "https://cdn-icons-png.flaticon.com/512/4727/4727443.png",
  },
  {
    title: "",
    details: "Learning & working against the clock",
    url: "https://cdn-icons-png.flaticon.com/512/4727/4727565.png",
  },
];

const resumeLink =
  "https://drive.google.com/file/d/1oeLslaLYTys_5yHj1SXIfukx8_onJpGL/view?usp=sharing";

const aboutMe =
  "I have a great passion for coding and developing new practical apps.<br> I am currently seeking full-time job where I can use my skills to make the world a better place while learning from experts.";
export { skillsDetails, aboutMe, resumeLink };
